import React from "react";
import Icon from "../../shared/Icon";
import className from "../../shared/className";

export default function SideNavLink({ href, onClick, selected, icon, text }) {
  return (
    <a href={href} onClick={onClick} {...className({ selected })}>
      {icon ? <Icon symbol={icon} /> : null}
      <span className="text-view">{text}</span>
    </a>
  );
}
